<template>
  <div class="card">
    <div class="card-body">
      <h5 class="card-title">{{ $t('addNewUnitProduct') }}</h5>
      <form @submit.prevent="createUnitProduct">
        <!--@submit.prevent="createProduct" to trigger event when click "submit"-->
        <div>
          <multiselect
            v-model="unitProduct.product"
            :options="productNames"
            :searchable="true"
            :close-on-select="true"
            label="name"
            placeholder="Select one product"
            :show-labels="false"
            :class="{ error: $v.unitProduct.product.$error }"
            @blur="$v.unitProduct.product.$touch()"
          ></multiselect>
          <!-- <pre class="language-json"><code>{{ productName  }}</code></pre> -->
        </div>

        <!--Form validation-->
        <template v-if="$v.unitProduct.product.$error">
          <p v-if="!$v.unitProduct.product.required" class="errorMessage">
            You need to select one product.
          </p>
        </template>

        <!-- <BaseInput
          class="field"
          label="stock (max)"
          v-model="unitProduct.stock_max"
          type="number"
          placeholder="max. stock No."
          :class="{ error: $v.unitProduct.stock_max.$error }"
          @blur="$v.unitProduct.stock_max.$touch()"
        /> -->
        <!--Form validation-->
        <!-- <template v-if="$v.unitProduct.stock_max.$error">
          <p v-if="!$v.unitProduct.stock_max.required" class="errorMessage">
            It is required to set a maximum stock for this product.
          </p>
        </template> -->

        <BaseInput
          class="field"
          label="Current stock"
          v-model="unitProduct.stock_curr"
          type="number"
          placeholder="Current stock"
          :class="{ error: $v.unitProduct.stock_curr.$error }"
          @blur="$v.unitProduct.stock_curr.$touch()"
        />
        <!--Form validation-->

        <template v-if="$v.unitProduct.stock_curr.$error">
          <p v-if="!$v.unitProduct.stock_curr.required" class="errorMessage">
            {{ $t('currentStockReq') }}
          </p>
        </template>

        <div class="optionalData">
          <p class="optional">{{ $t('optional') }}</p>
          <textarea
            class="field form-control"
            aria-label="With textarea"
            label="Comments"
            v-model="unitProduct.comments"
            type="text"
            placeholder="Add additional comments that might be userful for cleaners (max. 50 words)"
          />
        </div>
        <br/>

        <!-- <ImgUpload /> -->
        <BaseButton
          type="submit"
          buttonClass="-fill-gradient"
          :disabled="$v.$anyError"
          >{{ $t('add') }}</BaseButton
        >
        <p v-if="$v.anyError" class="errorMessage">
          Please fill out the required field(s)
        </p>
      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import NProgress from 'nprogress'
// import ProductService from '@/services/ProductService.js'
// import ImgUpload from '@/components/ui/ImgUpload.vue'
import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    // ImgUpload,
  },
  data() {
    return {
      productNames: [],
      productName: [],
      unitProduct: this.createFreshUnitProductObject(),
      selectedFile: null,
      unit: []
    }
  },
  validations: {
    unitProduct: {
      product: { required },
      comments: {},
      // stock_max: { required },
      stock_curr: { required }
    }
  },
  mounted() {
    axios
      .get(`${process.env.VUE_APP_API_URL}/products`)
      .then(response => (this.productNames = response.data))
  },

  methods: {
    createUnitProduct() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        NProgress.start()
        this.$store
          .dispatch('unitProduct/createUnitProduct', this.unitProduct)
          .then(() => {
            this.$router.push({
              name: 'unitProduct',
              params: { 
                unit_id: this.unitProduct.unitId,
                product_id: this.unitProduct.productId, 
              }
            })
            this.unitProduct = this.createFreshUnitProductObject()
          })
          .catch(() => {
            NProgress.done()
          })
      }
    },
    createFreshUnitProductObject() {
      const clientId = 2 // this.$store.state.client.client
      const unitId = 1  // this.$store.state.unit.unit
      const productId = 1  //this.$store.state.product.product
      // const id = Math.floor(Math.random() * 1000000)

      return {
        client_id: clientId,
        unit_id: unitId,
        product_id: productId,
        comments: '',
        stock_max: '',
        stock_curr: '',
        stock_actual: ''
      }
    }
  }
}
</script>

<style scoped>
@import '../../node_modules/vue-multiselect/dist/vue-multiselect.min.css';

.optionalData {
  background-color: var(--grey-light);
  border: 1px solid var(--grey);
  padding: 0 20px;
  width: 100%;
}
.optional {
  text-align: center;
  letter-spacing: 5px;
  color: var(--bg);
}

.card-body {
  color: #454655;
}
.field {
  margin-bottom: 24px;
}
.card {
  margin-top: 50px;
  margin-left: 60px;
}

.card-title {
  font-size: 30px;
}
p {
  text-align: left;
}

@media screen and (max-width: 560px){
.optionalData {
    padding: 10px;
  }
}

</style>
